import { createActions } from "redux-actions";

export const constants = {
  UPDATE_BLAST_FORM_FIELD: "UPDATE_BLAST_FORM_FIELD",
  SUBMIT_BLAST_FORM: "SUBMIT_BLAST_FORM",
};

export const actions = createActions({
  SUBMIT_BLAST_FORM: {
    REQUEST: ({ form }) => ({ form }),
    SUCCESS: (success) => success,
    FAILURE: (error) => error,
  },
});
